import * as types from "../actions/actionTypes";

const initialState = {
  list: {
    totalLeases: 0,
    leases: [],
    lastUpdatedLease: "",
  },
  details: {},
  names: [],
  cities: [],
  stateProvinces: [],
  countries: [],
  leaseTypes: [],
  leaseStatuses: [],
  eventTypes: [],
  tenureTypes: [],
  propertyTypes: [],
  relatedLeaseEvents: [],
  allLeases: {},
  leasePageSize: 10,
  distinctLeaseRegions: [],
};

export default function leaseReducer(state = initialState, action) {
  switch (action.type) {
    case types.GET_LEASES: {
      const { data } = action.payload;

      return {
        ...state,
        list: data,
        details: {},
      };
    }

    case types.GET_LEASE: {
      const { data } = action.payload;

      return {
        ...state,
        details: Array.isArray(data) ? data[0] : data,
        relatedLeaseEvents: []
      };
    }

    case types.GET_DISTINCT_LEASE_REGIONS: {
      const { data } = action.payload;

      return {
        ...state,
        distinctLeaseRegions: data?.length > 0 ? data : ["Not Specified"],
      };
    }

    case types.GET_LEASE_FILTER_OPTIONS: {
      const { data } = action.payload;

      const {
        names,
        cities,
        stateProvinces,
        countries,
        leaseTypes,
        leaseStatuses,
        tenureTypes,
        propertyTypes,
      } = data;

      return {
        ...state,
        names,
        cities,
        stateProvinces,
        countries,
        leaseTypes,
        leaseStatuses,
        tenureTypes,
        propertyTypes,
      };
    }

    case types.GET_LEASE_NAMES: {
      const { data } = action.payload;

      return {
        ...state,
        names: data,
      };
    }

    case types.GET_LEASE_CITIES: {
      const { data } = action.payload;

      return {
        ...state,
        cities: data,
      };
    }

    case types.GET_LEASE_STATE_PROVINCES: {
      const { data } = action.payload;

      return {
        ...state,
        stateProvinces: data,
      };
    }

    case types.GET_LEASE_COUNTRIES: {
      const { data } = action.payload;

      return {
        ...state,
        countries: data,
      };
    }

    case types.GET_LEASE_TYPES: {
      const { data } = action.payload;

      return {
        ...state,
        leaseTypes: data,
      };
    }

    case types.GET_LEASE_STATUSES: {
      const { data } = action.payload;

      return {
        ...state,
        leaseStatuses: data,
      };
    }

    case types.GET_LEASE_EVENT_TYPES: {
      const { data } = action.payload;

      return {
        ...state,
        eventTypes: data,
      };
    }

    case types.GET_TENURE_TYPES: {
      const { data } = action.payload;

      return {
        ...state,
        tenureTypes: data,
      };
    }

    case types.GET_RELATED_LEASE_EVENTS: {
      const { data } = action.payload;

      return {
        ...state,
        relatedLeaseEvents: data,
      };
    }  

    case types.GET_ALL_LEASES: {
      const { data } = action.payload;

      return {
        ...state,
        allLeases: data,
      };
    }

    case types.GET_LEASE_PAGE_SIZE: {
          const { data } = action.payload || {};
          return {
            ...state,
            leasePageSize: data,
          };
        }

    default:
      return state;
  }
}
